import styled from '@emotion/styled'
import { ESessionPhase } from '@lbs/shared-rp-types'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { useRussianPokerStore } from './useRussianPokerStore'
import { RpDealerButton } from '../../components'

export const yellow = '#FFC445'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const green = '#8BE589'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const red = '#EF0048'

const Text = styled.div<{
  variant: 'green' | 'red' | 'yellow'
}>`
  color: ${({ variant }) => {
    switch (variant) {
      case 'green':
        return green
      case 'red':
        return red
      case 'yellow':
        return yellow
      default:
        return 'red'
    }
  }};
  font-size: 50px;
  font-style: normal;
  font-weight: 510;
  line-height: normal;
  text-align: center;
  padding: 20px;
`

const Notice: FC<{}> = observer(() => {
  const { session, boxes, isOnlinePlayer, togglePopupExit } = useRussianPokerStore()
  if (!session) return null
  const { phase } = session

  const isHasSwitchCars = boxes.some((box) => box.pendingCardsRequest === 'switch')
  const isHasSixCard = boxes.some((box) => box.pendingCardsRequest === 'buySix')

  const isOnlyWaitDecision = phase === ESessionPhase.DECISIONS && !isHasSwitchCars && !isHasSixCard
  const waitSwitchCards = phase === ESessionPhase.DECISIONS && isHasSwitchCars
  const waitBuySixCard = phase === ESessionPhase.DECISIONS && isHasSixCard

  if (phase === ESessionPhase.BETTING) return <Text variant="yellow">Прием ставок...</Text>
  if (phase === ESessionPhase.DEALING) return <Text variant="yellow">Раздача карт...</Text>
  if (isOnlyWaitDecision) return <Text variant="yellow">Ожидание игрока...</Text>
  if (phase === ESessionPhase.SETTLEMENT) {
    if (session.pendingCardsRequest === 'buyGame') return <Text variant="yellow">Заменить старшую карту дилера!</Text>

    return <Text variant="yellow">Открыть карты!</Text>
  }

  if (phase === ESessionPhase.FINISHED) {
    if (!isOnlinePlayer) {
      return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <RpDealerButton
            bg="red"
            text="Покинуть игру"
            cb={() => {
              togglePopupExit()
            }}
          />
        </div>
      )
    }
    return <Text variant="green">Ожидание игрока...</Text>
  }

  if (waitSwitchCards)
    return (
      <Text variant="yellow">
        Замена карт на бокс №{boxes.find((box) => box.pendingCardsRequest === 'switch')?.seatNumber}
      </Text>
    )
  if (waitBuySixCard)
    return (
      <Text variant="yellow">
        6 карта на бокс №{boxes.find((box) => box.pendingCardsRequest === 'buySix')?.seatNumber}
      </Text>
    )

  return <Text variant="yellow">Прием ставок...</Text>
})

export default Notice
